import './styles.scss';
import {
  Button,
  Heading,
  Text,
  TextField,
  SelectField,
} from '@payourse/style-guide';
import Container from './Container';
import { fields } from '../utils';
import { useProfileContext } from '../context';

export function AddCryptoPair() {
  const {
    state,
    incrementStep,
    decrementStep,
    handleChange,
    handleSelectChange,
  } = useProfileContext();

  return (
    <Container>
      <div className="Profile__description">
        <Heading
          element="h3"
          size="xl"
          text="Let's add a crypto pair"
          className="Profile__title"
        />
        <Text
          size="m"
          weight="normal"
          text="Select asset, cash currency and rates. You can edit these later based on market demands"
        />
      </div>

      {Object.values(fields.pair).map(field => {
        if (field.type === 'select') {
          return (
            <SelectField
              {...field}
              options={field.options!}
              key={field.name}
              value={state[field.name]}
              className="Profile__field"
              onChange={handleSelectChange}
            />
          );
        }

        if (field.name === 'quantity') {
          return (
            <TextField
              {...field}
              key={field.name}
              value={state[field.name]}
              fieldTitle={state['crypto-asset']}
              className="Profile__field"
              onChange={handleChange}
            />
          );
        }

        if (field.name === 'base-rate') {
          const label =
            state['crypto-asset'] && state['cash-currency']
              ? `(${state['crypto-asset']}/${state['cash-currency']})`
              : '';

          return (
            <TextField
              {...field}
              label={`Set base rate ${label}`}
              key={field.name}
              value={state[field.name]}
              className="Profile__field"
              onChange={handleChange}
            />
          );
        }

        return (
          <TextField
            {...field}
            key={field.name}
            value={state[field.name]}
            className="Profile__field"
            onChange={handleChange}
          />
        );
      })}

      <div className="Profile__actions">
        <Button variant="outline" onClick={decrementStep}>
          Go back
        </Button>
        <Button variant="secondary" onClick={incrementStep}>
          Add
        </Button>
      </div>
    </Container>
  );
}
